import React from "react";
import { Users } from "lucide-react";

export const ReportICP = ({ strategy }) => {
  const icp = strategy.ideal_customer_profile || {};
  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-br from-emerald-900/30 to-slate-900 border border-emerald-500/30 rounded-2xl p-6">
        <div className="flex items-center gap-3 mb-4">
          <Users className="w-8 h-8 text-emerald-400" />
          <div>
            <p className="text-sm text-slate-400">Primary Customer</p>
            <h3 className="text-xl font-bold text-white">{icp.primary_demographic || "N/A"}</h3>
          </div>
        </div>
        <p className="text-slate-300">{icp.psychographic_profile || ""}</p>
      </div>
      {icp.pain_points && (
        <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
          <h3 className="font-semibold text-white mb-4">Pain Points</h3>
          <div className="space-y-2">
            {icp.pain_points.map((point) => (
              <div key={`pain-${point.slice(0, 30)}`} className="p-3 bg-red-900/20 border border-red-500/30 rounded-lg text-slate-300 text-sm">
                {point}
              </div>
            ))}
          </div>
        </div>
      )}
      {icp.buying_motivations && (
        <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
          <h3 className="font-semibold text-white mb-4">Buying Motivations</h3>
          <div className="space-y-2">
            {icp.buying_motivations.map((m) => (
              <div key={`motiv-${m.slice(0, 30)}`} className="p-3 bg-emerald-900/20 border border-emerald-500/30 rounded-lg text-slate-300 text-sm">
                {m}
              </div>
            ))}
          </div>
        </div>
      )}
      {icp.preferred_channels && (
        <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
          <h3 className="font-semibold text-white mb-4">Preferred Channels</h3>
          <div className="flex flex-wrap gap-2">
            {icp.preferred_channels.map((ch) => (
              <span key={`chan-${ch}`} className="px-4 py-2 bg-slate-800 text-slate-300 rounded-full text-sm">{ch}</span>
            ))}
          </div>
        </div>
      )}
      {icp.audience_segments && (
        <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
          <h3 className="font-semibold text-white mb-4">Audience Segments</h3>
          <div className="space-y-4">
            {icp.audience_segments.map((seg) => (
              <div key={`seg-${seg.audience_segment || seg.name}`} className="p-4 bg-slate-800/50 rounded-xl">
                <h4 className="font-semibold text-emerald-400 mb-2">{seg.audience_segment || seg.name}</h4>
                {seg.description && <p className="text-slate-300 text-sm mb-2">{seg.description}</p>}
                {seg.messaging_approach && <p className="text-slate-400 text-sm"><span className="text-slate-500">Messaging:</span> {seg.messaging_approach}</p>}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
